import SearchPanel from 'bee-search-panel'

export default SearchPanel
